// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingGiftcardSearchResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type WidgetBookingGiftcardSearchApiResponse = {
	amountRemaining: number;
	amountConsumed: number;
	expiresAt: string;
	code: string;
};

export type WidgetBookingGiftcardSearch = {
	amountRemaining: number;
	amountConsumed: number;
	expiresAt: DateTime;
	code: string;
};

export function hydrateWidgetBookingGiftcardSearch(data: WidgetBookingGiftcardSearchApiResponse): WidgetBookingGiftcardSearch {
	return {
		...data,
		expiresAt: DateTimefromISO(data.expiresAt)!,
	};
}